import { render } from "./service-order.vue?vue&type=template&id=4dd4eb6a"
import script from "./service-order.vue?vue&type=script&lang=js"
export * from "./service-order.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__